import { SVGProps } from "react";

export const InnoveraIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        transform="translate(2.4 2.4)"
        d="M9.49875 0.228027H10.3552L19.464 18.2864H9.33512L9.80597 17.2136L17.6529 17.236L15.5919 13.1576H15.5893L14.3073 10.6336L9.92608 1.92962L5.54484 10.6336L4.26285 13.1576H4.26024L1.66926 18.2872H0.388136L9.49875 0.228027Z"
        fill="#18181B"
      />
      <path
        transform="translate(2.4 2.4)"
        d="M-5.63341e-07 18.5136H1.82682L9.92525 2.4712L17.2639 17.0072L9.6389 16.9856L8.96875 18.5144H19.8522L10.5127 0H9.34039L9.27424 0.132L-5.63341e-07 18.5136ZM1.5109 18.0584H0.775469L9.65631 0.4552H10.1968L19.0759 18.0584H9.70157L9.97224 17.4408L18.0411 17.464L14.531 10.5368L9.92525 1.3872L1.51002 18.0584H1.5109Z"
        fill="#18181B"
      />
    </svg>
  );
};
